<div id="smallScreenWarning" class="small-screen-warning">
  <div class="empty-icon">
    <i class="fa-sharp fa-light fa-desktop" data-fa-transform="grow-100"></i>
  </div>
  <h1>Hey Designer, make your screen bigger please.</h1>
  <p>Our Box Designer experience requires a larger screen size. Please enlarge your browser window. If
    you need assistance give us a call at <b>877.926.3223</b>.</p>
  </div>

  <h1 class="visually-hidden">Box Designer</h1>
  <div class="visually-hidden" role="status" aria-live="polite">{{ canvasAnnouncement }}</div>
  <div id="pageContainer" class="page-container">
    @if (pageLoading || savingProject) {
      <app-loading-modal [content]="isContinuing ? 'Loading Review Page' : 'Loading Project'" [showLoadingBar]="true">
        Loading your custom project. Thank you for your patience!
      </app-loading-modal>
    }
    <div [style.visibility]="pageLoading ? 'hidden' : 'initial'" class="design-toolbar">
      <div class="toolbar-tools"
        [ngClass]="{'highlight': helpSection=='toolbarExplanation'}"
        [popover]="toolbarExplanationContent" [isOpen]="helpSection=='toolbarExplanation'"
        placement="bottom" container="body" triggers=""
        containerClass="tour-popover">
        <button type="button" class="toolbar-button" (click)="duplicateSelection()">
          <i class="fa-sharp fa-light fa-copy"></i>
          <span class="label">Duplicate</span>
        </button>
        <button type="button" class="toolbar-button" (click)="moveBackward()">
          <i class="fa-sharp fa-light fa-angle-left"></i>
          <span class="label">Move Backward</span>
        </button>
        <button type="button" class="toolbar-button" (click)="moveForward()">
          <i class="fa-sharp fa-light fa-angle-right"></i>
          <span class="label">Move Forward</span>
        </button>
        <button type="button" class="toolbar-button" [class.selected]="rulersActive"
                [ngClass]="{'highlight': helpSection=='rulerExplanation', 'active': helpSection=='rulerExplanation'}"
                [popover]="rulerExplanationContent" [isOpen]="helpSection=='rulerExplanation'"
                placement="bottom" container="body" triggers=""
                containerClass="tour-popover"
                [attr.aria-pressed]="rulersActive" (click)="toggleRulers()">
          <i class="fa-sharp fa-light fa-ruler-combined fa-rotate-90"></i>
          <span class="label">Rulers</span>
        </button>
        <button type="button" class="toolbar-button" (click)="undo()">
          <i class="fa-sharp fa-light fa-rotate-left"></i>
          <span class="label">Undo</span>
        </button>
        <button type="button" class="toolbar-button" (click)="redo()">
          <i class="fa-sharp fa-light fa-rotate-right"></i>
          <span class="label">Redo</span>
        </button>
        <button type="button" class="toolbar-button" (click)="confirmClearAll()">
          <i class="fa-sharp fa-light fa-x"></i>
          <span class="label">Clear All</span>
        </button>
        <button type="button" class="toolbar-button" (click)="deleteSelection()">
          <i class="fa-sharp fa-light fa-trash-can"></i>
          <span class="label">Delete</span>
        </button>
        <button type="button" class="toolbar-button" [class.selected]="shortcutsActive"
                [attr.aria-pressed]="shortcutsActive" (click)="openShortcuts()">
          <i class="fa-sharp fa-light fa-lightbulb-on"></i>
          <span class="label">Shortcuts</span>
        </button>
      </div>
      <button type="button" class="add-to-cart-button"
        [ngClass]="{'highlight': helpSection=='addToCartExplanation'}"
        [popover]="addToCartExplanationContent" [isOpen]="helpSection=='addToCartExplanation'"
        placement="bottom" container="body" triggers=""
        containerClass="tour-popover" (click)="requestUnityGoToCart()">
        <i class="fas fa-cart-shopping"></i>
        <span>ADD<span class="d-none d-lg-inline"> TO CART</span></span>
      </button>
    </div>
    <div [style.visibility]="pageLoading ? 'hidden' : 'initial'" class="content-container">
      <div [ngClass]="{'highlight': helpSection=='elementExplanation' }" class="vertical-menu"
        [popover]="elementExplanationContent" [isOpen]="helpSection=='elementExplanation'"
        placement="right" container="body" triggers=""
        containerClass="tour-popover">

        <div class="section-title top">
          <h2>DESIGN</h2>
        </div>

        <div class="upper-menu">
          <div [class.second-menu-active]="activeButton[0]">
            <button type="button" class="category patterns" (click)="changeActiveMenu('Patterns', 0)">
              <i class="fa-sharp fa-light fa-grid-round"></i>
              <span>Patterns</span>
            </button>
          </div>
          <div [class.second-menu-active]="activeButton[1]">
            <button type="button" class="category shapes" (click)="changeActiveMenu('Shapes', 1)">
              <i class="fa-sharp fa-light fa-shapes"></i>
              <span>Shapes</span>
            </button>
          </div>
          <div [class.second-menu-active]="activeButton[2]">
            <button type="button" class="category text" (click)="changeActiveMenu('Text', 2)">
              <i class="fa-sharp fa-light fa-t"></i>
              <span>Text</span>
            </button>
          </div>
          <div [class.second-menu-active]="activeButton[3]">
            <button type="button" class="category images" (click)="changeActiveMenu('Images', 3)">
              <i class="fa-sharp fa-light fa-image"></i>
              <span>Images</span>
            </button>
          </div>
          <button type="button" class="category review-details" (click)="changeActiveMenu('Review Details', 5)" [class.second-menu-active]="activeButton[5]">
            <i class="fa-sharp fa-light fa-layer-group"></i>
            <span>Material <br>& Finish</span>
          </button>
        </div>

        <div class="help-menu">
          <div class="horizontal-bar"></div>
          <div class="section-title">
            <h2>HELP</h2>
          </div>
<!--
          <button type="button" id="designTutorialButton" class="category vid"
            [class.second-menu-active]="activeButton[7]" (click)="!helpView ? changeActiveMenu1('Help', 7) : false"
            [popover]="tutorialPromptContent" [isOpen]="activeButton[7]"
            placement="right" container="body" triggers=""
            containerClass="tour-popover">
            <i class="fa-sharp fa-light fa-circle-play"></i>
            <span>Tutorial</span>
          </button>
-->
          <button type="button" id="Help" class="category help" (click)="!helpView ? changeActiveMenu('Help', 6) : false"
            [class.second-menu-active]="activeButton[6]"
            [popover]="guidedTourPromptContent" [isOpen]="activeButton[6]"
            placement="right" container="body" triggers=""
            containerClass="tour-popover">
            <i class="fa-sharp fa-light fa-compass"></i>
            <span>Guided<br>Tour</span>
          </button>
        </div>
      </div>

      <div class="design-stage">
      <div class="second-menu-shell" [class.open]="secondMenuOpen">
      @if (activeButton[0]) {
        <div class="second-menu" [ngClass]="{'highlight': helpSection=='patternExplanation' }"
          [popover]="patternExplanationContent" [isOpen]="helpSection=='patternExplanation'"
          placement="right" container="body" triggers=""
          containerClass="tour-popover">
          <div class="menu-header">
            <h3>Does your design need<br> a background?</h3>
            <div class="brown-bar"></div>
          </div>
          <div class="pattern-container" #patternContainerEl>
            @for (collection of patternCollections; track trackByFn($index, collection)) {
              <div>
                <h5>{{collection.name | uppercase}}</h5>
                <div class="patterns-list">
                  @for (pattern of getCollectionPatterns(collection.id); track trackByFn($index, pattern)) {
                    <div class="thumbnail-container">
                      <img [src]="pattern.previewUrl" [alt]="pattern.name" (click)="requestUnityAddPattern(pattern)">
                    </div>
                  }
                </div>
              </div>
            }
            <div [scrollContainer]="patternContainerEl" (nearBottom)="loadMorePatterns()" appInfiniteScrollSentinel></div>
          </div>
          <button (click)="openPatternLibrary(patternLibrary)" class="big-button">VIEW ENTIRE LIBRARY</button>
          <a class="bottom-link" (click)="changeActiveMenu('', -1)">Collapse</a>
        </div>
      }

      @if (activeButton[1]) {
        <div class="second-menu" [ngClass]="{'highlight': helpSection=='patternExplanation' }">
          <div class="menu-header">
            <h3>Does your design need special shapes?</h3>
            <div class="brown-bar"></div>
          </div>
          <div class="shape-container" #shapeContainerEl>
            @for (collection of shapeCollections; track trackByFn($index, collection)) {
              <div>
                <h5>{{collection.name | uppercase}}</h5>
                <div class="shape-list">
                  @for (shape of getCollectionShapes(collection.id); track trackByFn($index, shape)) {
                    <div>
                      <app-canvas-shape [shape]="shape" [location]="'menu'" (click)="requestUnityAddShape(shape)"></app-canvas-shape>
                    </div>
                  }
                </div>
              </div>
            }
            <div [scrollContainer]="shapeContainerEl" (nearBottom)="loadMoreShapes()" appInfiniteScrollSentinel></div>
          </div>
          <button (click)="openShapeLibrary(shapeLibrary)" class="big-button">VIEW ENTIRE LIBRARY</button>
          <a class="bottom-link" (click)="changeActiveMenu('', -1)">Collapse</a>
        </div>
      }

      @if (activeButton[2]) {
        <div class="second-menu text-menu">
          <div class="menu-header">
            <h3>Does your design<br> need text?</h3>
            <div class="brown-bar"></div>
          </div>
          <p>Personalize your design by adding custom text!</p>
          <button (click)="requestUnityAddText()" (mouseenter)="showWhiteLogo('addText')" (mouseleave)="showRedLogo('addText')"> <img
          [src]="addTextSrc" alt="">ADD TEXT</button>
          <a class="bottom-link" (click)="changeActiveMenu('', -1)">Collapse</a>
        </div>
      }

      @if (activeButton[3]) {
        <div class="second-menu">
          <div class="menu-header">
            <h3>Does your design need images or logos?</h3>
            <div class="brown-bar"></div>
          </div>
          <button (click)="showModal(uploadImage)" class="image-menu-button" (mouseenter)="showWhiteLogo('addImage')"
            (mouseleave)="showRedLogo('addImage')">
            <img [src]="addImageSrc" alt="">ADD IMAGE</button>
            <button (click)="showModal(uploadPixabay)" class="image-menu-button" (mouseenter)="showWhiteLogo('addPixabay')"
              (mouseleave)="showRedLogo('addPixabay')"> <img [src]="addPixabaySrc" alt="">ADD PIXABAY</button>
              <h5>YOUR UPLOADED IMAGES</h5>
              @if (images.length != 0) {
                <div class="pattern-container image-container">
                  @if (updatingImages) {
                    <div>
                      <img src="assets/cb/images/loading_box.gif" alt="">
                    </div>
                  }
                  @if (!updatingImages) {
                    <div class="patterns-list">
                      @for (image of images; track trackByFn($index, image)) {
                        <div class="image-container" (click)="requestUnityAddImage(image)"
                          [ngStyle]="{background: 'url(&quot;' + image.src + '&quot;)'}">
                          <div (click)="updatingImages = true; removeImage(image)" class="background-hover-button">
                            <div class="background-hover-button-content"></div>
                          </div>
                        </div>
                      }
                    </div>
                  }
                </div>
              }
              <a class="bottom-link" (click)="changeActiveMenu('', -1)">Collapse</a>
            </div>
      }

      @if (activeButton[5]) {
        <div class="second-menu">
          <div class="menu-header">
            <h3>Review the details you've chosen</h3>
            <div class="brown-bar"></div>
          </div>
          @if (!isPaddedMailer) {
            <h5 class="box-details-title">My Box Details</h5>
          }
          @if (isPaddedMailer) {
            <h5 class="box-details-title">My Mailer Details</h5>
          }
          <div class="box-details">
            @if (!isPaddedMailer) {
              <p [innerHTML]="productDetails.categoryName"></p>
              @if (selectedPreset.label && !productDetails.customSizeEntered) {
                <p>{{selectedPreset.label}}</p>
              }
              @if (productDetails.customSizeEntered || !selectedPreset.label) {
                <p>{{productDetails.BoxDimensions}} (in)</p>
              }
            }
            @if (isPaddedMailer) {
              <p>{{selectedPreset.label}}</p>
            }
          </div>
          @if (!isTissue) {
            <form>
              <div class="form-group">
                <mat-label>Printing </mat-label><br>
                <mat-form-field appearance="outline">
                  <mat-select name="printing" disableOptionCentering="true" [(ngModel)]="printing">
                    @for (printing of printingOptions; track trackByFn($index, printing)) {
                      <mat-option (click)="printingSelected(printing)"
                      [value]="printing">{{printing}}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
              <!-- @if (categoryCode !=='Event Boxes' && !isOtherProduct && !isPaddedMailer) {
                <div class="form-group">
                  <mat-label>Material</mat-label><br>
                  <mat-select name="material" disableOptionCentering="true" [(ngModel)]="material" (selectionChange)="updateForm()">
                    @for (material of materialOptions; track trackByFn($index, material)) {
                      <mat-option [value]="material">{{material}}</mat-option>
                    }
                  </mat-select>
                </div>
              } -->
              @if (!isOtherProduct) {
                <div class="form-group">
                  <mat-label>@if (!isPaddedMailer) {
                    <span>Outer </span>
                  }Material</mat-label><br>
                  <mat-form-field appearance="outline">
                    <mat-select name="outerMaterial" disableOptionCentering="true" [(ngModel)]="outerMaterial" (selectionChange)="updateForm()">
                      @for (outerMaterial of outerMaterialOptions; track trackByFn($index, outerMaterial)) {
                        <mat-option [value]="outerMaterial">{{outerMaterial}}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
              }
              @if (!isPaddedMailer && !isOtherProduct) {
                <div class="form-group">
                  <mat-label>Inner Material</mat-label><br>
                  <mat-form-field appearance="outline">
                    <mat-select name="innerMaterial" disableOptionCentering="true" [(ngModel)]="innerMaterial" (selectionChange)="updateForm()">
                      @for (innerMaterial of innerMaterialOptions; track trackByFn($index, innerMaterial)) {
                        <mat-option [value]="innerMaterial">{{innerMaterial}}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
              }
              @if (!isPaddedMailer && !isOtherProduct) {
                <div class="form-group">
                  <mat-label>Finish</mat-label><br>
                  <mat-form-field appearance="outline">
                    <mat-select name="finish" disableOptionCentering="true" [(ngModel)]="finish" (selectionChange)="updateForm()">
                      @for (finish of finishOptions; track trackByFn($index, finish)) {
                        <mat-option [value]="finish">{{finish}}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
              }
            </form>
          }
          <a class="bottom-link" (click)="changeActiveMenu('', -1)">Collapse</a>
        </div>
      }
      </div>

      <ng-template #guidedTourPromptContent>
        <h3>NEED A LITTLE HELP?</h3>
        <p>Click here for a guided tour.</p>
        <div class="help-options">
          <a (click)="changeActiveMenu('', -2)" class="exit-tour">NO THANKS</a>
          <a (click)="changeActiveMenu('', -1); showHelpSection('elementExplanation')" class="continue-tour">START TOUR</a>
        </div>
      </ng-template>
      <ng-template #tutorialPromptContent>
        <h3>NEED A LITTLE HELP?</h3>
        <p>Click here to watch the tutorial.</p>
        <div class="help-options">
          <a (click)="changeActiveMenu1('', -2)" class="exit-tour">CLOSE</a>
          <a (click)="showModal(Video)" class="continue-tour">START VIDEO</a>
        </div>
      </ng-template>
      <div
        [ngClass]="{'highlight': helpSection=='designAreaExplanation' || helpSection=='customBoxExplanation' || helpSection=='viewerExplanation' }"
        [class.shifted]="secondMenuOpen"
        class="webgl-content">
        <div class="legend-toolbar">
          <div class="legend-key">
            <span class="legend-item"><span class="legend-swatch bleed"></span>Bleed</span>
            <span class="legend-item"><span class="legend-swatch crease"></span>Crease</span>
            <span class="legend-item"><span class="legend-swatch cut"></span>Cut</span>
          </div>
          <button type="button" class="legend-button" #legendPopover="bs-popover"
            [popover]="legendPopoverContent" placement="bottom" container="body"
            containerClass="key-popover me-3" triggers="click" [outsideClick]="true">
            <i class="fa-sharp fa-light fa-circle-info me-1"></i>
            <span>Legend</span>
          </button>
        </div>
        <div #gameContainer id="gameContainer"></div>
        <div class="bottom-actions">
          <div class="side-toggle-group">
            @if (twoSided) {
              <div class="side-toggle"
                [ngClass]="{'highlight': helpSection=='twoSidedExplanation'}"
                [popover]="twoSidedExplanationContent" [isOpen]="(twoSidedPrintingAdded && !twoSidedTipDismissed) || helpSection=='twoSidedExplanation'"
                placement="top" container="body" triggers=""
                containerClass="tour-popover">
                <span class="side-toggle-label">Showing:</span>
                <div class="side-toggle-buttons">
                  <button type="button" class="side-toggle-button" [class.active]="showingSide === 'outside'"
                          [attr.aria-pressed]="showingSide === 'outside'"
                          (click)="toggleShowingSide('outside')">OUTSIDE</button>
                  <button type="button" class="side-toggle-button" [class.active]="showingSide === 'inside'"
                          [attr.aria-pressed]="showingSide === 'inside'"
                          (click)="toggleShowingSide('inside')">INSIDE</button>
                </div>
              </div>
            } @else {
              <div class="side-toggle"
                [ngClass]="{'highlight': helpSection=='twoSidedExplanation'}"
                [popover]="twoSidedExplanationContent" [isOpen]="helpSection=='twoSidedExplanation'"
                placement="top" container="body" triggers=""
                containerClass="tour-popover">
                <span class="side-toggle-label">Showing:</span>
                <div class="side-toggle-buttons">
                  @if (insideOnly) {
                    <button type="button" class="side-toggle-button" [class.disabled]="true" disabled
                            aria-pressed="false"
                            (click)="toggleShowingSide('outside')">OUTSIDE</button>
                    <button type="button" class="side-toggle-button active"
                            aria-pressed="true"
                            (click)="toggleShowingSide('inside')">INSIDE</button>
                  } @else {
                    <button type="button" class="side-toggle-button active"
                            aria-pressed="true"
                            (click)="toggleShowingSide('outside')">OUTSIDE</button>
                    <button type="button" class="side-toggle-button" [class.disabled]="true" disabled
                            aria-pressed="false"
                            (click)="toggleShowingSide('inside')">INSIDE</button>
                  }
                </div>
              </div>
            }
          </div>
          <div class="right-actions">
            @if (twoSided) {
              <button type="button" class="cancel-two-sided-link" (click)="confirmCancelTwoSidedPrinting()">
                Cancel two-sided print
              </button>
            } @else if (selectedSubcategory?.displayTwoSided) {
              <button type="button" class="two-sided-button" (click)="promptTwoSidedPrinting()">
                <i class="fa fa-plus"></i>
                <span>Two-Side Printing</span>
              </button>
            }
            <button type="button" class="download-button" #downloadButtonEl #downloadPopover="bs-popover"
              [popover]="downloadPopoverContent" placement="top" container="body"
              containerClass="download-popover" triggers="click" [outsideClick]="true"
              (onShown)="matchDownloadPopoverWidth()">
              <span class="download-button-label">Download</span>
              <span class="download-button-chevron"><i class="fa-sharp fa-light fa-chevron-down"></i></span>
            </button>
          </div>
        </div>
      </div>
      </div>
    </div>

    <ng-template #legendPopoverContent>
      <div class="legend-popover-header">
        <span>Legend</span>
        <button type="button" class="legend-popover-close" aria-label="Close legend" (click)="legendPopover.hide()">
          <i class="fa-sharp fa-light fa-xmark"></i>
        </button>
      </div>
      <div class="legend-popover-content">
        <div class="legend-modal-item">
          <span class="legend-swatch bleed"></span>
          <div class="legend-modal-text">
            <b>Bleed</b>
            <p>"Bleed" is the portion of a printed design that extends beyond the trim area to prevent unprinted edges after cutting.</p>
          </div>
        </div>
        <div class="legend-modal-item">
          <span class="legend-swatch crease"></span>
          <div class="legend-modal-text">
            <b>Crease</b>
            <p>The "crease" refers to a line or fold made in the paper to facilitate bending or folding without damaging the material.</p>
          </div>
        </div>
        <div class="legend-modal-item">
          <span class="legend-swatch cut"></span>
          <div class="legend-modal-text">
            <b>Cut</b>
            <p>A "cut" line indicates where the material should be trimmed to achieve the final size of the printed piece.</p>
          </div>
        </div>
      </div>
    </ng-template>

    <ng-template #downloadPopoverContent>
      <div class="download-popover-list">
        <button type="button" (click)="downloadPopover.hide(); downloadPDF()">Download PDF</button>
        <button type="button" (click)="downloadPopover.hide(); downloadSVG()">Download SVG</button>
      </div>
    </ng-template>

  <!------------------------------------------------ BEGINNING OF MODALS ------------------------------------------------>

  <ng-template #uploadImage>
    <app-image-upload [containerID]="containerID" [user]="authService.getUser()" (imageAdded)='getImagesForUI(); hide()' (hideModal)="hide()">
    </app-image-upload>
  </ng-template>

  <ng-template #uploadPixabay>
    <app-pixabay-modal [containerId]="containerID" [user]="authService.getUser()" (pixabayAdded)='getImagesForUI(); hide()'>
    </app-pixabay-modal>
  </ng-template>

  <ng-template #patternLibrary>
    <app-pattern-library [patterns]="patterns" [patternCollections]="patternCollections"
      (patternSelected)="requestUnityAddPattern($event); hide();" (hideModal)="hide()" (loadMore)="loadMorePatterns()">
    </app-pattern-library>
  </ng-template>

  <ng-template #shapeLibrary>
    <app-shape-library [shapes]="shapes" [shapeCollections]="shapeCollections"
    (shapeSelected)="requestUnityAddShape($event); hide();" (hideModal)="hide()" (loadMore)="loadMoreShapes()"></app-shape-library>
  </ng-template>
  <ng-template #leavingPageWarning>
    <div class="modal-header pb-0 border-0">
      <div class="modal-title">
        <h1>Have you forgotten something?</h1>
      </div>
    </div>
    <div class="modal-body">
      <div class="container-fluid">
        <p>Before you leave, save your progress, or changes made to your design will be lost.</p>
      </div>
      <div class="multi-button-container">
        <button type="button" class="white-submit" (click)="navigationChoice(true)">Continue</button>
        <button type="button" class="white-submit" (click)="navigationChoice(false)">Cancel</button>
      </div>
    </div>
  </ng-template>

  <ng-template #helpModal>
    <div class="modal-header pb-0 border-0">
      <div class="modal-title page-title eyebrow">
        <h1>Keyboard Shortcuts</h1>
      </div>
      <button type="button" class="close-button pull-right" aria-label="Close" (click)="hide()">
        <i class="fa-sharp fa-light fa-xmark"></i>
      </button>
    </div>
    <div class="modal-body">
      <div class="container-fluid help-container">
        <div class="col">
          <div class="legend-modal-list">
            <div class="legend-modal-item">
              <b class="shortcut-key">Shift + Arrows</b>
              <div class="legend-modal-text">
                <p>Move the selected object</p>
              </div>
            </div>
            <div class="legend-modal-item">
              <b class="shortcut-key">{{ modifierKeyLabel }} + Arrows</b>
              <div class="legend-modal-text">
                <p>Resize the selected object</p>
              </div>
            </div>
            <div class="legend-modal-item">
              <b class="shortcut-key">Shift + Delete</b>
              <div class="legend-modal-text">
                <p>Deletes the selected object</p>
              </div>
            </div>
            <div class="legend-modal-item">
              <b class="shortcut-key">{{ modifierKeyLabel }} + X</b>
              <div class="legend-modal-text">
                <p>Clear all</p>
              </div>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="legend-modal-list">
            <div class="legend-modal-item">
              <b class="shortcut-key">{{ modifierKeyLabel }} + D</b>
              <div class="legend-modal-text">
                <p>Duplicate selected item</p>
              </div>
            </div>
            <div class="legend-modal-item">
              <b class="shortcut-key">{{ modifierKeyLabel }} + F</b>
              <div class="legend-modal-text">
                <p>Bring the selected item forward</p>
              </div>
            </div>
            <div class="legend-modal-item">
              <b class="shortcut-key">{{ modifierKeyLabel }} + B</b>
              <div class="legend-modal-text">
                <p>Send the selected item backward</p>
              </div>
            </div>
            <div class="legend-modal-item">
              <b class="shortcut-key">{{ modifierKeyLabel }} + R</b>
              <div class="legend-modal-text">
                <p>Display the rulers</p>
              </div>
            </div>
            <div class="legend-modal-item">
              <b class="shortcut-key">{{ modifierKeyLabel }} + U</b>
              <div class="legend-modal-text">
                <p>Undo latest action</p>
              </div>
            </div>
            <div class="legend-modal-item">
              <b class="shortcut-key">{{ modifierKeyLabel }} + Shift + R</b>
              <div class="legend-modal-text">
                <p>Redo latest undone action</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="multi-button-container">
        <button type="button" class="white-submit" (click)="hide()">OK</button>
      </div>
    </div>
  </ng-template>

  <ng-template #twoSidedWarning>
    <div class="modal-header pb-0 border-0">
      <div class="modal-title two-sided-modal-title">
        <h1>Add Two-sided Printing?</h1>
      </div>
      <button type="button" class="close-button pull-right" aria-label="Close" (click)="hide(); cancelPendingPrinting();">
        <i class="fa-sharp fa-light fa-xmark"></i>
      </button>
    </div>
    <div class="modal-body">
      <div class="container-fluid">
        <p>For a better unpacking experience, upgrade your box to two-sided printing.</p>
        <p>Would you like to add two-sided printing?</p>
      </div>
      <div class="button-container">
        <button type="button" class="white-submit" (click)="hide(); requestUnityAddTwoSidePrinting();">Yes</button>
        <button type="button" class="white-submit" (click)="hide(); cancelPendingPrinting();">No</button>
      </div>
    </div>
  </ng-template>

  <ng-template #cancelTwoSidedWarning>
    <div class="modal-header pb-0 border-0">
      <div class="modal-title two-sided-modal-title">
        <h1>Remove Two-sided Printing?</h1>
      </div>
      <button type="button" class="close-button pull-right" aria-label="Close" (click)="hide(); cancelPendingPrinting();">
        <i class="fa-sharp fa-light fa-xmark"></i>
      </button>
    </div>
    <div class="modal-body">
      <div class="container-fluid">
        <p>This will remove two-sided printing and discard your inside design. This cannot be undone.</p>
      </div>
      <div class="button-container">
        <button type="button" class="white-submit" (click)="hide(); cancelTwoSidedPrinting();">OK</button>
        <button type="button" class="white-submit" (click)="hide(); cancelPendingPrinting();">CANCEL</button>
      </div>
    </div>
  </ng-template>
  <ng-template #Video>
    <div class="modal-header1">

      <iframe #video width="1100" height="600" src="https://www.youtube.com/embed/2gCGo-i0RpU" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </div>

  </ng-template>

  <ng-template #blankBoxWarning>
    <div class="name-design-container">
      <h4>Blank Design</h4>

      <p>One or more sides of your design is blank, is that correct?</p>
      <div class="button-container">
        <button type="button" class="white-submit" (click)="hide(); saveCanvasImages();">YES</button>
        <button type="button" class="white-submit" (click)="isSaveInProgress=false; hide();">NO</button>
      </div>
    </div>
  </ng-template>

  <!-- <ng-template #login>
  <app-login-modal [reload]='false' (loginSuccess)='hide(); getUser();'></app-login-modal>
</ng-template> -->


  <!-------------------------------------- HELP TUTORIAL MODALS -------------------------------------->

  @if (helpView) {
    <div (click)="hide()" class='help-view-background'></div>
  }
  @if (helpSection=='designAreaExplanation' || helpSection=='customBoxExplanation' || helpSection=='viewerExplanation') {
    <div (click)="hide()"
      [ngClass]="{'right-cover': helpSection=='designAreaExplanation', 'center-cover': helpSection=='customBoxExplanation' || helpSection=='viewerExplanation'}"
    class='help-view-piece-background'></div>
  }

  <ng-template #elementExplanationContent>
    <p>Add elements like backgrounds, images, and text to your design.</p>
    <div class="help-options">
      <span class="tour-option"><a (click)="hide()" class="exit-tour">EXIT TOUR</a><span class="tour-shortcut">(X)</span></span>
      <span class="tour-option"><a (click)="advanceTour()" class="continue-tour">NEXT</a><span class="tour-shortcut">(N)</span></span>
    </div>
  </ng-template>

  <ng-template #patternExplanationContent>
    <p>Search, browse, or open the full gallery of options for each design element.</p>
    <div class="help-options">
      <span class="tour-option"><a (click)="hide()" class="exit-tour">EXIT TOUR</a><span class="tour-shortcut">(X)</span></span>
      <span class="tour-option"><a (click)="advanceTour()" class="continue-tour">NEXT</a><span class="tour-shortcut">(N)</span></span>
    </div>
  </ng-template>

  <ng-template #toolbarExplanationContent>
    <p>Set of global tools that help duplicate, move, undo, redo, delete, even start over. Remember to save your work or add to cart.</p>
    <div class="help-options">
      <span class="tour-option"><a (click)="hide()" class="exit-tour">EXIT TOUR</a><span class="tour-shortcut">(X)</span></span>
      <span class="tour-option"><a (click)="advanceTour()" class="continue-tour">NEXT</a><span class="tour-shortcut">(N)</span></span>
    </div>
  </ng-template>

  <ng-template #rulerExplanationContent>
    <p>Toggle rulers to help you position your graphics.</p>
    <div class="help-options">
      <span class="tour-option"><a (click)="hide()" class="exit-tour">EXIT TOUR</a><span class="tour-shortcut">(X)</span></span>
      <span class="tour-option"><a (click)="advanceTour()" class="continue-tour">NEXT</a><span class="tour-shortcut">(N)</span></span>
    </div>
  </ng-template>

  <ng-template #twoSidedExplanationContent>
    <p>Switch between your outside and inside design views.</p>
    <div class="help-options">
      @if (twoSidedPrintingAdded) {
        <a (click)="twoSidedTipDismissed = true; hide()" class="continue-tour">OK</a>
      }
      @if (helpView) {
        <span class="tour-option"><a (click)="hide()" class="exit-tour">EXIT TOUR</a><span class="tour-shortcut">(X)</span></span>
        <span class="tour-option"><a (click)="advanceTour()" class="continue-tour">NEXT</a><span class="tour-shortcut">(N)</span></span>
      }
    </div>
  </ng-template>

  <ng-template #addToCartExplanationContent>
    <p>When your design is completed, add it to the cart.</p>
    <div class="help-options">
      <span class="tour-option"><a (click)="advanceTour()" class="continue-tour">FINISH TOUR</a><span class="tour-shortcut">(N)</span></span>
    </div>
  </ng-template>

  @if (helpSection=='designAreaExplanation') {
    <div class="design-area-explanation popover bs-popover-end">
      <div class="popover-arrow arrow"></div>
      <div class="popover-body">
        <p>2D design area. Your added elements will display here to be edited.</p>
        <div class="help-options">
          <span class="tour-option"><a (click)="hide()" class="exit-tour">EXIT TOUR</a><span class="tour-shortcut">(X)</span></span>
          <span class="tour-option"><a (click)="advanceTour()" class="continue-tour">NEXT</a><span class="tour-shortcut">(N)</span></span>
        </div>
      </div>
    </div>
  }

  @if (helpSection=='customBoxExplanation') {
    <div class="custom-box-explanation popover bs-popover-start">
      <div class="popover-arrow arrow"></div>
      <div class="popover-body">
        <p>Tools specific to your design element will display here to edit each item.</p>
        <div class="help-options">
          <span class="tour-option"><a (click)="hide()" class="exit-tour">EXIT TOUR</a><span class="tour-shortcut">(X)</span></span>
          <span class="tour-option"><a (click)="advanceTour()" class="continue-tour">NEXT</a><span class="tour-shortcut">(N)</span></span>
        </div>
      </div>
    </div>
  }

  @if (helpSection=='viewerExplanation') {
    <div class="viewer-explanation popover bs-popover-start">
      <div class="popover-arrow arrow"></div>
      <div class="popover-body">
        <p>Interactive 3D viewer to display your design in real-time.</p>
        <div class="help-options">
          <span class="tour-option"><a (click)="hide()" class="exit-tour">EXIT TOUR</a><span class="tour-shortcut">(X)</span></span>
          <span class="tour-option"><a (click)="advanceTour()" class="continue-tour">NEXT</a><span class="tour-shortcut">(N)</span></span>
        </div>
      </div>
    </div>
  }
</div>

@if (downloadUrl) {
  <iframe [src]="downloadUrl" style="border: none;" width="1" height="1"></iframe>
}

<ng-template #notFoundModal>
  <app-not-found-modal></app-not-found-modal>
</ng-template>
  <ng-template #userIdle>
  <div class="modal-header pb-0 border-0">
    <div class="modal-title">
      <h1>Psst...your session is about to expire.</h1>
    </div>
  </div>
  <div class="modal-body">
    <div class="container-fluid">
      <p>You will be logged out in {{ idleSession.remainingSeconds() }} seconds to protect your account. <br>Please click "Continue" and be sure to save or you may lose your design.</p>
    </div>
    <div class="button-container">
      <button type="button" class="white-submit" (click)="continue()">Continue</button>
    </div>
  </div>
</ng-template>
